<div class="home-kachel" [class.homeKachelWba]="os != 'web'">
  <div class="home contentblock" [class.homeWba]="os != 'web'" *ngIf="startseite" [innerHTML]="startseite | img | async"></div>
</div>
